export default "__VITE_ASSET__CmgdxCCU__"